export default {
  GET_RESERVATIONS: (state) => state.reservations,
  GET_RESERVATION: (state) => state.reservation,
  GET_RESERVATION_STATUSES: (state) => state.statuses,
  GET_RESERVATION_ACTIONS: (state) => state.actions,
};
